/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsBaseForKubernetesClusterCloud extends models.ServiceAccountNativeDetailsBaseForKubernetesCluster {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsBaseForKubernetesClusterCloud");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsBaseForKubernetesClusterCloud.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsBaseForKubernetesClusterCloud>): ServiceAccountNativeDetailsBaseForKubernetesClusterCloud {
        let obj = Object.assign(new ServiceAccountNativeDetailsBaseForKubernetesClusterCloud(), model);
        ServiceAccountNativeDetailsBaseForKubernetesClusterCloud.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsBaseForKubernetesClusterCloud>): ServiceAccountNativeDetailsBaseForKubernetesClusterCloud {
        if (!model) return null;
        return ServiceAccountNativeDetailsBaseForKubernetesClusterCloud.newInstance(<ServiceAccountNativeDetailsBaseForKubernetesClusterCloud> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsBaseForKubernetesClusterCloud) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsBaseForKubernetesClusterCloud.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsBaseForKubernetesClusterCloud): boolean {
        if (models.ServiceAccountNativeDetailsBaseForKubernetesCluster.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsBaseForKubernetesClusterCloud.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Region/Zone/Resource group where the cluster is hosted.
     */
    location: string;

}
